import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { timeout } from 'rxjs/operators';
import { getEndpoint } from 'src/app/core/services/functions.service';
import { CasoData, SolicitudLiberacion } from '../liberar-cita/models/liberacion.models';

export interface RespuestaCaso {
  success: boolean;
  message: string;
  /** Codigo de negocio del back (ej. CASO_NO_ENCONTRADO); no viene en errores tecnicos. */
  codigo?: string;
  data?: CasoData;
  resultados?: { lado: string; resultado: string; mensaje: string }[];
}

const MENSAJE_TIMEOUT = 'Se ha agotado el tiempo de espera para la peticion realizada.<br/>Reintentar nuevamente dentro de unos segundos.';

/** Busqueda y liberacion de casos postventa: rutas nuevas de la lambda de liberar pedidos (url_lambda_liberar_pedido). */
@Injectable({
  providedIn: 'root'
})
export class LiberacionCasoService {

  constructor(private http: HttpClient) { }

  getDataCaso(numCaso: string, cEmp: string): Promise<RespuestaCaso> {
    const url = getEndpoint('url_lambda_liberar_pedido') + 'logistica/basicDataCaso?c_emp=' + cEmp + '&num_caso=' + numCaso;
    return this.llamar(this.http.get<any>(url), numCaso);
  }

  releaseCase(caso: CasoData, cEmp: string, usuario: string, solicitud: SolicitudLiberacion): Promise<RespuestaCaso> {
    const url = getEndpoint('url_lambda_liberar_pedido') + 'logistica/releaseCase';
    const body = {
      c_emp: cEmp,
      num_caso: caso.num_caso,
      usuario,
      causal: solicitud.causal.COD_CAUSAL,
      descripcion_causal: solicitud.causal.DES,
      observaciones: solicitud.detalle
    };
    return this.llamar(this.http.post<any>(url, body), caso.num_caso);
  }

  /** Respuesta de negocio (406 con codigo) se devuelve tal cual; timeout y errores tecnicos llevan solo mensaje. */
  private async llamar(peticion: any, numCaso: string): Promise<RespuestaCaso> {
    const result: any = await peticion.pipe(timeout(29000)).toPromise().then((r: any) => r).catch((e: any) => e);

    if (result && result.name === 'TimeoutError') {
      return { success: false, message: MENSAJE_TIMEOUT };
    }
    if (result instanceof HttpErrorResponse) {
      const cuerpo = result.error || {};
      if (result.status === 406 && cuerpo.codigo) {
        return {
          ...cuerpo,
          message: cuerpo.codigo === 'CASO_NO_ENCONTRADO'
            ? `No encontramos el caso ${numCaso}. Revisa el número y vuelve a intentar.`
            : cuerpo.message
        };
      }
      return { success: false, message: cuerpo.message || 'Se ha presentado un error en la peticion al servidor.' };
    }
    return result;
  }
}
